/**
 * Investors Datatable Field Configurations
 * 
 * Defines all available field metadata for the investors datatable including display names,
 * CSS styling classes, and field data types. Used for filtering, sorting, and column
 * visibility management. Each field object contains actualName (database field name),
 * displayName (UI label), cName (CSS class for styling), and type (text, boolean, etc).
 */

// all available field attributes for the data table that are referred to
export const allInvestorsFields = [
  {
    actualName: "name",
    displayName: "Name",
    cName: "",
    type: "text",
  },
  {
    actualName: "investorType",
    displayName: "Investor type",
    cName: " sticky detailmediumdata",
    type: "text",
  },
  {
    actualName: "description",
    displayName: "Description",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "numOfFailedInvestments",
    displayName: "No. of failed investments",
    cName: "detailmldata",
    type: "quantity",
  },
  {
    actualName: "lossOnInvestments",
    displayName: "Loss on investments",
    cName: "detailmldata",
    type: "quantity",
  },
  {
    actualName: "shutteredPortfolioCompanies",
    displayName: "Shuttered portfolio companies",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "portfolioCompanies",
    displayName: "Portfolio companies",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "numOfExit",
    displayName: "No. of exits",
    cName: "detailshortdata",
    type: "quantity",
  },
  {
    actualName: "exitValue",
    displayName: "Total exit value",
    cName: "detailshortdata",
    type: "quantity",
  },
  {
    actualName: "reputation",
    displayName: "Investor reputation",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "location",
    displayName: "Location",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "investmentStage",
    displayName: "Preferred investment stage(s)",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "investmentTrackRecord",
    displayName: "Stages invested in",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "assets",
    displayName: "Assets under management (AUM)",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "investmentRange",
    displayName: "Investment range",
    cName: "detaillongdata",
    type: "quantity",
  },
  {
    actualName: "sweetSpot",
    displayName: "Investment sweet spot",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "investmentFocus",
    displayName: "Preferred investment focus",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "investmentGeography",
    displayName: "Preferred investment geography",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "numOfInvestments",
    displayName: "No. of investments",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "numOfLeadInvestments",
    displayName: "No. of lead investments",
    cName: "detailmldata",
    type: "quantity",
  },
  {
    actualName: "numOfFollowOnInvestments",
    displayName: "No. of follow-on investments",
    cName: "detailmldata",
    type: "quantity",
  },
  {
    actualName: "numOfCoInvestments",
    displayName: "No. of co-investments",
    cName: "detailmldata",
    type: "quantity",
  },
  {
    actualName: "numOfAcquisitions",
    displayName: "No. of acquisitions",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "boardSeats",
    displayName: "No. of board seats taken",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "numOfFunds",
    displayName: "No. of funds",
    cName: "detailshortdata",
    type: "quantity",
  },
  {
    actualName: "limitedPartners",
    displayName: "Limited partners",
    cName: "detailshortdata",
    type: "text",
  },
  {
    actualName: "coInvestors",
    displayName: "Co-investors",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "numofPartners",
    displayName: "No. of partners",
    cName: "detailshortdata",
    type: "quantity",
  },
  {
    actualName: "partners",
    displayName: "Partners",
    cName: "detailshortdata",
    type: "text",
  },
  {
    actualName: "numOfEmployeesObj",
    displayName: "No. of employees",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "management",
    displayName: "Management",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "boardMembers",
    displayName: "Board members",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "founders",
    displayName: "Founders",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "email",
    displayName: "Email",
    cName: "detailmediumdata breakword",
    type: "text",
  },
  {
    actualName: "socialMedia",
    displayName: "Social media",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "website",
    displayName: "Website",
    cName: "detailmediumdata breakword",
    type: "text",
  },
  {
    actualName: "phone",
    displayName: "Phone no.",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "address",
    displayName: "Address",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "entityType",
    displayName: "Entity type",
    cName: "detailshortdata",
    type: "text",
  },
  {
    actualName: "legalName",
    displayName: "Legal name",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "primaryBusinessName",
    displayName: "Other business name(s)",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "formerlegalName",
    displayName: "Former legal name(s)",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "founded",
    displayName: "Founded date",
    cName: "detailshortdata",
    type: "date",
  },
  {
    actualName: "stockSymbol",
    displayName: "Ticker",
    cName: "detailshortdata",
    type: "text",
  },
];
